/* @jsxImportSource react */

import { Link } from '@packages/shared/src/components/Link/Link';

export type Datasheet = {
  url: string;
  name: string;
};

export interface ProductCardV2DatasheetLinkProps {
  datasheet: Datasheet;
  ariaDescribedBy?: string;
}

export const ProductCardV2DatasheetLink = ({
  datasheet,
  ariaDescribedBy,
}: ProductCardV2DatasheetLinkProps) => (
  <Link
    noLinkStyle
    href={datasheet.url}
    target="_blank"
    className="text-size-body3 text-color-text-dark hover:text-color-grey-dark hyphens-auto underline"
    aria-describedby={ariaDescribedBy}
  >
    {datasheet.name}
  </Link>
);
